import NestedForm from 'stimulus-rails-nested-form'

export default class extends NestedForm {
  static targets = ['inputs', 'removeButtonWrapper']
  static classes = ['hidden']

  connect() {
    super.connect()

    this.intervalId = setInterval(() => {
      this.addInputsIfNecessary()
      this.toggleRemoveButtons()
    }, 200)
  }

  addInputsIfNecessary (event) {
    const dummyEvent = { preventDefault: function () {} }
    if (this.needsMoreInputs()) {
      this.add(dummyEvent)
    }
  }

  disconnect () {
    super.disconnect()
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  isEmpty (inputsTarget) {
    const fields = Array.from(inputsTarget.querySelectorAll('input:not([disabled]):not([type="hidden"]), textarea:not([disabled])'))

    return fields.every(function (input) {
      return input.value.trim() === ''
    })
  }


  needsMoreInputs () {
    return this.numberOfInputsTargetsWithoutUserInput() < 1
  }

  numberOfInputsTargetsWithoutUserInput () {
    return this.visibleInputTargets().filter((inputsTarget) => {
      return this.isEmpty(inputsTarget)
    }).length
  }

  toggleRemoveButtons () {
    const visibleTargets = this.visibleInputTargets()
    const emptyTargets = visibleTargets.filter((target) => this.isEmpty(target))

    // Hide removeButton when there is only one empty target
    visibleTargets.forEach((inputsTarget) => {
      const wrapper = inputsTarget.closest('.nested-form-wrapper')
      const removeButtonWrapper = wrapper.querySelector('[data-nested-form-target="removeButtonWrapper"]')

      if (!removeButtonWrapper) return

      const shouldHideButton = emptyTargets.length === 1 && this.isEmpty(inputsTarget)
      removeButtonWrapper.classList.toggle(this.hiddenClass, shouldHideButton)
    })
  }

  visibleInputTargets () {
    return this.inputsTargets.filter((inputsTarget) => {
      const wrapper = inputsTarget.closest('.nested-form-wrapper')

      // Skip if wrapper is not present
      if (!wrapper) return false

      // Skip if wrapper is hidden
      if (wrapper.classList.contains(this.hiddenClass)) return false

      // Skip if destroy field is present and marked for destruction
      const destroyField = wrapper.querySelector('input[name*="_destroy"]')
      if (destroyField && destroyField.value === '1') return false

      return true
    })
  }
}
